const COLORS = {
  verde: "#10b981",
  amarelo: "#f59e0b",
  cinza: "#374151",
};

export function TermGrid({
  palpites,
  letrasAtuais,
  linhaAtual,
  maxTentativas,
  indexAtivo,
  onCellClick,
  cellSize = 40,
}) {
  const cells = [];
  for (let row = 0; row < maxTentativas; row += 1) {
    for (let column = 0; column < 5; column += 1) {
      if (row < linhaAtual) cells.push(palpites[row][column]);
      else if (row === linhaAtual) {
        cells.push({
          letra: letrasAtuais[column],
          cor: "atual",
          row,
          column,
        });
      } else cells.push({ letra: "", cor: null, row, column });
    }
  }
  const fontSize = Math.max(13, Math.min(32, Math.round(cellSize * 0.48)));

  return (
    <div
      className="termo-grade-board"
      style={{
        gridTemplateColumns: `repeat(5, ${cellSize}px)`,
        gridAutoRows: `${cellSize}px`,
      }}
    >
      {cells.map((cell, index) => {
        const row = Math.floor(index / 5);
        const column = index % 5;
        const active = row === linhaAtual && column === indexAtivo;
        const border = active
          ? "2px solid #818cf8"
          : cell?.cor === "atual"
            ? "2px solid #6b7280"
            : cell?.cor
              ? "2px solid transparent"
              : "2px solid #374151";
        return (
          <button
            className="letra-box termo-cell"
            onClick={() => row === linhaAtual && onCellClick?.(column)}
            style={{
              width: cellSize,
              height: cellSize,
              fontSize,
              backgroundColor: COLORS[cell?.cor] || "transparent",
              border,
              cursor: row === linhaAtual ? "pointer" : "default",
            }}
            type="button"
            key={index}
          >
            {cell?.letra || ""}
          </button>
        );
      })}
    </div>
  );
}
